module.exports = __webpack_public_path__ + "img/website-icon.54c500a6.svg";